module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_3_3.b2edec88.png";